import axios from "axios";

const API = axios.create({
    baseURL: "https://horyzen-technologies.onrender.com/api"
});

export const submitApplication = (formData) => {
    return API.post("/applications", formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};